import { Coffee } from 'lucide-react';
import { SUPPORT_URL } from '../../constants';

export default function SupportSection() {
  return (
    <section className="border-t border-slate-200/80 bg-slate-50 py-14">
      <div className="mx-auto max-w-2xl px-4 text-center sm:px-6">
        <p className="text-sm leading-relaxed text-slate-600">
          PixelUtility is an independent project creating free modern tools for
          everyone. If this tool helped you, consider supporting future development.
        </p>
        <a
          href={SUPPORT_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="mt-5 inline-flex items-center gap-2 rounded-xl bg-white px-5 py-2.5 text-sm font-medium text-slate-800 ring-1 ring-slate-200 transition hover:bg-slate-50"
        >
          <Coffee className="h-4 w-4 text-amber-600" />
          Support PixelUtility
        </a>
      </div>
    </section>
  );
}
